import React from "react";
import { motion } from "framer-motion";

const BenefitSection = ({benefits}) => {
  return (
    <div className="row gy-4">
      {benefits.map((ben, idx) => {
        const IconComp = ben.icon;
        return (
          <motion.div
            className="col-md-6"
            key={idx}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="card h-100 shadow-sm p-4">
              <div className="d-flex">
                <IconComp size={32} className="text-primary me-2" />
                <div>
                  <h5 className="card-title">{ben.title}</h5>
                  <p className="card-text">{ben.description}</p>
                </div>
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default BenefitSection;
